var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("history-grant-access-menu", {
        model: {
          value: _vm.showGrantAccessHistoryModal,
          callback: function($$v) {
            _vm.showGrantAccessHistoryModal = $$v
          },
          expression: "showGrantAccessHistoryModal"
        }
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.state.layout.showMenu,
            expression: "$store.state.layout.showMenu"
          }
        ],
        staticClass: "backgroundOverlay"
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "slide-fade-left" },
          on: {
            "after-enter": _vm.onAfterEnterMenuTransition,
            "before-leave": _vm.onBeforeLeaveMenuTransition
          }
        },
        [
          _vm.$store.state.layout.showMenu
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hideMenu,
                      expression: "hideMenu"
                    }
                  ],
                  staticClass: "menuOverlay",
                  on: { click: _vm.handleMenuClick }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-close",
                      attrs: {
                        id: "navbar-toggler",
                        type: "button",
                        "aria-label": "Close"
                      },
                      on: { click: _vm.hideMenu }
                    },
                    [
                      _c("base-icon", {
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                          color: _vm.WHITE_COLOUR,
                          svgClasses: _vm.caretIconClasses
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "overlayItems" },
                    [
                      _vm.$store.state.session.user
                        ? _c(
                            "b-row",
                            { staticClass: "profile" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "text-bold",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "profile-pic mr-2 d-inline-block",
                                    attrs: {
                                      src: _vm.$store.state.session.user.photo
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ml-0 d-inline-block text-transform-uppercase font-weight-bold text-underline",
                                      on: { click: _vm.goProfile }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.session.user.name
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.$store.getters["session/userIsPatient"]
                                ? _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "small btn-change-user",
                                        on: {
                                          click: function($event) {
                                            return _vm.$store.commit(
                                              "layout/toggleChangeUserModalVisible"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("menu.change-user"))
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr", { staticClass: "divider" }),
                      _vm._v(" "),
                      !_vm.inPanel &&
                      _vm.$store.getters["session/userIsPatient"]
                        ? _c(
                            "div",
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    outline: "",
                                    white: "",
                                    href: "/patient",
                                    size: "sm"
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/patient", tag: "span" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("private-layout.home")
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "divider" })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.menuServiceItems && _vm.menuServiceItems.length > 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "menuItem",
                                  attrs: { id: "services-toggler" },
                                  on: { click: _vm.toggleShowServicesMenu }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("private-layout.services")
                                      ) +
                                      " \n\t\t\t\t\t\t"
                                  ),
                                  _c("base-icon", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                                      color: _vm.WHITE_COLOUR,
                                      svgClasses: _vm.caretSubMenuClass,
                                      height: 12,
                                      width: 12
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("CollapseTransition", [
                                _vm.showServicesMenu
                                  ? _c(
                                      "div",
                                      { staticClass: "submenu pl-3 mt-3" },
                                      _vm._l(_vm.menuServiceItems, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: "list-items-" + index },
                                          [
                                            _c(
                                              "a",
                                              { on: { click: item.action } },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "menuItem" },
                                                  [_vm._v(_vm._s(item.title))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.isLastItem(
                                              index,
                                              _vm.menuServiceItems
                                            )
                                              ? _c("hr")
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("hr")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.allMenuItems, function(items, listIndex) {
                        return _c(
                          "div",
                          { key: "list-items-" + listIndex },
                          [
                            _vm._l(items, function(item, itemIndex) {
                              return _c("div", { key: item.title }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onTabClick(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "menuItem" }, [
                                      _vm._v(_vm._s(item.title))
                                    ]),
                                    _vm._v(" "),
                                    item.bubble
                                      ? _c(
                                          "b-badge",
                                          {
                                            staticClass: "ml-1",
                                            attrs: { variant: "secondary" }
                                          },
                                          [_vm._v(_vm._s(item.bubble))]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isLastItem(itemIndex, items)
                                  ? _c("hr")
                                  : _vm._e()
                              ])
                            }),
                            _vm._v(" "),
                            _c("hr", { staticClass: "divider" })
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      !_vm.$store.getters["session/userIsPatient"]
                        ? _c("div", [
                            _vm.$store.getters["session/userIsProfessional"]
                              ? _c("a", [
                                  _c("p", { staticClass: "menuItem" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("private-layout.telemonitoring")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$store.getters["session/userIsProfessional"]
                              ? _c("hr")
                              : _vm._e(),
                            _vm._v(" "),
                            _c("a", [
                              _c("p", { staticClass: "menuItem" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("private-layout.dashboard"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "divider" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("lang-selector", {
                        staticClass:
                          "d-inline-block mr-4 text-center font-weight-normal",
                        attrs: {
                          color: _vm.WHITE_COLOUR,
                          enablePortuguese: "",
                          labeled: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.$store.state.session.user
                        ? _c("a", { on: { click: _vm.logOff } }, [
                            _c("p", { staticClass: "menuItem" }, [
                              _vm._v(_vm._s(_vm.$t("logOff")))
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f8a7e3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8a7e3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PrivateLayoutMobileSubmenu.vue
// module id = 2070
// module chunks = 116